import { IFilters } from "constants/filters";

export enum CustomViewAuthor {
  Agent = "agent",
  System = "system",
}

export interface ICustomView {
  id: string;
  name: string;
  filters: IFilters;
  createdBy: string;
  createdByType?: CustomViewAuthor;
  createdAt: string;
  agentID: string | null;
  shared?: boolean;
}

export interface ICustomViewWithStatus extends ICustomView {
  invalid: boolean;
  number?: number;
}
